import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { SettingsReadyForOutboundDateInformationDto, readyForOutboundDateInformationValidationSchema } from 'dtos'
import { Formik } from 'formik'
import { ExplanationAccordion } from 'components'

interface ReadyForOutboundAddEditDialogProps {
  initialValues: SettingsReadyForOutboundDateInformationDto
  open: boolean
  isLoading: boolean
  onClose: () => void
  onSave: (values: any) => void
}

export default function ReadyForOutboundAddEditDialog({
  open,
  onClose,
  onSave,
  isLoading,
  initialValues
}: ReadyForOutboundAddEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnChange
        validateOnBlur
        validationSchema={readyForOutboundDateInformationValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Ready For Outbound Date</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading || isSubmitting}
                      error={Boolean(
                        touched.readyForOutboundNumberOfDaysBeforeVehicleRelease &&
                          errors.readyForOutboundNumberOfDaysBeforeVehicleRelease
                      )}
                      helperText={
                        touched.readyForOutboundNumberOfDaysBeforeVehicleRelease &&
                        errors.readyForOutboundNumberOfDaysBeforeVehicleRelease
                      }
                      label='Days Prior to Vehicle Release Date'
                      name='readyForOutboundNumberOfDaysBeforeVehicleRelease'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='number'
                      value={values.readyForOutboundNumberOfDaysBeforeVehicleRelease}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <ExplanationAccordion variant='outlined'>
                    ||All fields are required. || The Ready for Outbound Date is the date when vehicles may be added to Outbound
                    Trips. This control exists so that vehicles may be added to Outbound Trips before the Vehicle Release Date
                    is reached (the 30-day hold expires). Note that a vehicle immediately becomes “Ready for Outbound” when the
                    Bond Release document for the vehicle is OCR'd and attached to the VIN, regardless of the Vehicle Release
                    Date or Ready for Outbound Date controls. ||
                  </ExplanationAccordion>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={isLoading || isSubmitting} variant='text' color='inherit' onClick={onClose}>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
